<template>
  <select-with-buttons :options="[
                           {value: 1, text: 1, class: ['scoreButton']},
                           {value: 2, text: 2, class: ['scoreButton']},
                           {value: 3, text: 3, class: ['scoreButton']},
                           {value: 4, text: 4, class: ['scoreButton']},
                           {value: 5, text: 5, class: ['scoreButton']},
                           {value: 6, text: 6, class: ['scoreButton']},
                           {value: 7, text: 7, class: ['scoreButton']},
                           {value: 0, text: $t('calls.pass'), size: 2, class: ['pass']}
                       ]"
                       row-size="4"
                       @click="propagateClick">
  </select-with-buttons>
</template>
<script>
import SelectWithButtons from '../lib/SelectWithButtons';

export default {
  name: 'select-contract-level',
  components: {SelectWithButtons},
  props: {},
  methods: {
    propagateClick(clicked) {
      this.$emit('click', clicked);
    }
  }
};
</script>

<style scoped>
>>> .pass {
  background-color: green;
  color: white;
  border: initial !important;
}
</style>